module.exports = __webpack_public_path__ + "static/media/John+Varvatos+8th+Annual+Stuart+House+Benefit+rIgrTm5M3q6x.5babf886.jpg";